import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { useAccordion } from './useAccordion.js';
export { useAccordion } from './useAccordion.js';

var _excluded = ["allowMultipleExpanded", "as", "children"];
var Accordion = /*#__PURE__*/React__default.forwardRef(function Accordion(props, ref) {
  var allowMultipleExpanded = props.allowMultipleExpanded,
      Heading = props.as,
      children = props.children,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var regions = useAccordion(children, allowMultipleExpanded);
  var accordionSections = regions.map(function (region) {
    var className = cn({
      'yt-accordion__expanded': region.isExpanded
    });
    return React__default.createElement(React__default.Fragment, {
      key: region.trigger.id
    }, React__default.createElement(Heading, {
      className: className
    }, React__default.createElement("button", Object.assign({}, region.trigger, {
      ref: region.ref
    }), region.trigger.children, React__default.createElement(Icon, {
      name: region.isExpanded ? 'chevron-up' : 'chevron-down'
    }))), React__default.createElement("div", Object.assign({}, region.region)));
  });
  var className = cn('yt-accordion', props.className);
  return React__default.createElement("div", Object.assign({}, otherProps, {
    className: className,
    ref: ref
  }), accordionSections);
});

Accordion.Region = function () {
  return null;
};

export { Accordion };
//# sourceMappingURL=Accordion.js.map
